import { ApiResponse } from '../types';
import { API_URL } from '../../common/utils';

/**
 * Sube un archivo PDF de constancia fiscal al servidor
 * @param orderId - ID de la orden 
 * @param file - Archivo PDF a subir
 * @param cfdiUse - Uso de CFDI
 * @param paymentMethod - Método de pago
 * @param taxRegime - Régimen fiscal
 * @returns Promesa con la respuesta de la API
 */
const uploadCsfFile = async (orderId: string, file: File, cfdiUse: string, paymentMethod: string, taxRegime: string, rfc: string): Promise<ApiResponse> => {
  try {
    const formData = new FormData();
    formData.append('order', orderId);
    formData.append('file', file);
    formData.append('cfdiUse', cfdiUse);
    formData.append('paymentMethod', paymentMethod);
    formData.append('taxRegime', taxRegime);
    formData.append('rfc', rfc);
    
    const response = await fetch(`${API_URL}/files/upload`, {
      method: 'POST',
      body: formData,
    });
    
    if (!response.ok) {
      throw new Error(`Error al subir el archivo: ${response.statusText}`);
    }
    
    const data: ApiResponse = await response.json();
    return data;
  } catch (error) {
    console.error('Error al subir el archivo:', error);
    throw error;
  }
}; 

export {
  uploadCsfFile,
};